<script>
import App from "@/pages/layouts/app.vue";
import Form from '@/pages/customer_products/_form.vue';
import UpdateForm from "@wielink-application/shared/js/mixins/updateForm";

export default {
  mixins: [UpdateForm],
  components: {App, Form},
  props: ['customer_product_id', 'customer'],
  data() {
    return {
      formRoute: route('api.v1.customers.products.update', {'customer': this.customer.id, 'customer_product': this.customer_product_id} ),
      redirectRoute: route('customers.products.index',{'customer': this.customer.id}),
    }
  },
  methods: {
    afterSuccess(form, response) {
      this.getCustomerProduct();
    },

    getCustomerProduct() {
      this.loading = true;
      $.ajax({
        url: route('api.v1.customers.products.show', {'customer': this.customer.id, 'customer_product': this.customer_product_id}),
        success: (response) => {
          this.$refs.form.setCustomerProduct(response.data);
        }
      }).always(() => {
        this.loading = false;
      })
    }
  },
  mounted() {
    this.getCustomerProduct();
  }
}
</script>

<template>
  <App title="Product koppeling bewerken">
    <form id="customerProductForm" @submit.prevent="submit">
      <Form ref="form"/>
    </form>

    <template #bottomButtons>
      <FormButtons
          @backToOverview="stayOnPage = 0"
          :loading="loading"
          form-id="customerProductForm"
          :cancel-route="redirectRoute"
      />
    </template>
  </App>
</template>